import * as React from "react";
import { FieldRenderProps } from "@progress/kendo-react-form";
import { Switch, SwitchChangeEvent } from "@progress/kendo-react-inputs";
import { Hint, Error, Label } from "@progress/kendo-react-labels";
import { CgDanger } from "react-icons/cg";
import IconComponent from "../common/IconComponent";

interface FormSwitchProps extends FieldRenderProps {
  label?: string;
  hint?: string;
  wrapperClassName?: string;
  wrapperStyle?: React.CSSProperties;
  fieldClassName?: string;
  astrike?: boolean;
  isEditAccess?: boolean;
  size?: "small" | "medium" | "large";
}

const FormSwitchField: React.FC<FormSwitchProps> = (props) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperClassName,
    wrapperStyle,
    fieldClassName,
    astrike = false,
    size = "medium",
    value,
    onChange,
    onBlur,
    ...others
  } = props;

  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : "";
  const errorId = showValidationMessage ? `${id}_error` : "";

  const handleChange = React.useCallback(
    (event: SwitchChangeEvent) => {
      onChange({ value: event.value });
    },
    [onChange]
  );

  return (
    <div className={wrapperClassName} style={wrapperStyle}>
      <div className="d-flex align-items-center gap-2">
        {label && (
          <Label
            editorId={id}
            editorValid={valid}
            editorDisabled={disabled}
            style={{ marginBottom: 0 }}
          >
            {label} {astrike && <span style={{ color: "red" }}>*</span>}
          </Label>
        )}
        <Switch
          className={fieldClassName}
          checked={!!value}
          valid={valid}
          disabled={disabled}
          size={size}
          onChange={handleChange}
          onBlur={onBlur}
          aria-describedby={`${hintId} ${errorId}`}
          {...others}
        />
      </div>

      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && (
        <Error className="d-flex justify-content-end" id={errorId}>
          <span
            className="d-flex align-items-center"
            style={{
              background: "#DF4957",
              color: "white",
              padding: "1px 8px 1px 5px",
              borderRadius: 10,
              gap: 5,
            }}
          >
            <IconComponent icon={CgDanger} /> {validationMessage}
          </span>
        </Error>
      )}
    </div>
  );
};

export default FormSwitchField;
